/* Restore server-rendered cart state when returning through browser history. */
window.addEventListener('pageshow', event => {
  const navigation = performance.getEntriesByType('navigation')[0];
  if (event.persisted || navigation?.type === 'back_forward') {
    // A reload gets fresh Liquid cart markup and becomes type "reload", avoiding a loop.
    window.location.reload();
  }
});

(()=>{
if(customElements.get('kassandra-ph-page'))return;
customElements.define('kassandra-ph-page',class extends HTMLElement{
 connectedCallback(){
  if(this._abort)return;this._abort=new AbortController();const opt={signal:this._abort.signal};
  this.addEventListener('click',e=>{
   const cartLink=e.target.closest('.kav-header-actions a[aria-label="Καλάθι"]');
   if(cartLink&&document.querySelector('cart-drawer')){e.preventDefault();document.dispatchEvent(new CustomEvent('theme:cart:toggle',{bubbles:true}));}
   const thumb=e.target.closest('[data-kav-thumb]');
   if(thumb){const img=this.querySelector('[data-kav-main-image]');if(img){img.src=thumb.dataset.src;img.srcset=thumb.dataset.srcset||'';img.alt=thumb.dataset.alt||'';this.querySelectorAll('[data-kav-thumb]').forEach(b=>b.setAttribute('aria-pressed',String(b===thumb)));}}
  },opt);
  const form=this.querySelector('[data-kav-form]');const button=form?.querySelector('[type=submit]');const status=this.querySelector('[data-kav-loading]');
  if(this.dataset.preview==='true'){
   document.querySelector('[data-kav-review-toggle]')?.addEventListener('click',e=>{const active=e.currentTarget.getAttribute('aria-pressed')!=='true';e.currentTarget.setAttribute('aria-pressed',String(active));e.currentTarget.textContent=active?'Ocultar blocos pendentes':'Mostrar blocos pendentes';this.querySelectorAll('[data-review-slot]').forEach(x=>x.hidden=!active);},opt);
   form?.addEventListener('submit',e=>{e.preventDefault();status.hidden=false;status.textContent='Προεπισκόπηση μόνο — δεν προστέθηκε προϊόν στο καλάθι.';},opt);
  }else if(this.dataset.kaching==='true'&&form&&button){
   const ready=()=>{const loaded=form.querySelector('.kaching-bundles__block--loaded');if(loaded){button.disabled=this.dataset.available!=='true';if(status)status.hidden=true;this._observer?.disconnect();clearTimeout(this._timer);}};
   button.disabled=true;this._observer=new MutationObserver(ready);this._observer.observe(form,{childList:true,subtree:true,attributes:true,attributeFilter:['class']});ready();
   this._timer=setTimeout(()=>{if(!form.querySelector('.kaching-bundles__block--loaded')&&status){status.hidden=false;status.classList.add('is-error');status.textContent='Οι επιλογές αγοράς δεν φορτώθηκαν. Ανανεώστε τη σελίδα ή επικοινωνήστε μαζί μας.';}},15000);
   // The theme's product-form submits through the native cart drawer; Kaching augments that request.
  }
  const buybox=this.querySelector('[data-kav-buybox]');const sticky=this.querySelector('[data-kav-sticky]');
  if(buybox&&sticky){const update=()=>{this._raf=0;sticky.classList.toggle('is-visible',buybox.getBoundingClientRect().bottom<0);};const schedule=()=>{if(!this._raf)this._raf=requestAnimationFrame(update);};window.addEventListener('scroll',schedule,{passive:true,signal:this._abort.signal});window.addEventListener('resize',schedule,opt);update();}
 }
 disconnectedCallback(){this._abort?.abort();this._abort=null;this._observer?.disconnect();cancelAnimationFrame(this._raf);clearTimeout(this._timer);}
});
})();

/* Review data and press animation are independent of the native product form. */
(() => {
  if (!customElements.get('kassandra-ph-press')) customElements.define('kassandra-ph-press', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this.querySelector('button')?.addEventListener('click', event => {
        const paused = this.classList.toggle('is-paused');
        event.currentTarget.setAttribute('aria-pressed', String(paused));
        event.currentTarget.setAttribute('aria-label', paused ? 'Συνέχιση κίνησης λογοτύπων' : 'Παύση κίνησης λογοτύπων');
        event.currentTarget.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
      }, { signal: this._abort.signal });
    }
    disconnectedCallback() { this._abort?.abort(); this._abort = null; }
  });
  if (!customElements.get('kassandra-ph-reviews')) customElements.define('kassandra-ph-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      try { this.reviews = JSON.parse(this.querySelector('[data-kav-reviews-data]').textContent); } catch { return; }
      this._abort = new AbortController();
      this.page = 1; this.pageSize = 5; this.sort = 'source';
      this.list = this.querySelector('[data-review-list]');
      this.pagination = this.querySelector('[data-review-pagination]');
      this.status = this.querySelector('[data-review-status]');
      this.dialog = this.querySelector('dialog');
      const options = { signal: this._abort.signal };
      this.querySelector('[data-review-sort]').addEventListener('change', event => {
        this.sort = event.target.value; this.page = 1; this.render(false);
      }, options);
      this.addEventListener('click', event => {
        const pageButton = event.target.closest('[data-review-page]');
        if (pageButton && !pageButton.disabled) { this.page = Number(pageButton.dataset.reviewPage); this.render(true); }
        const photoButton = event.target.closest('[data-review-photo]');
        if (photoButton) {
          const review = this.reviews.find(item => item.id === Number(photoButton.dataset.reviewPhoto));
          if (!review?.image) return;
          const image = this.dialog.querySelector('img');
          image.src = review.image.replace(/([?&])w=160\b/, '$1w=1024');
          image.alt = 'Φωτογραφία αξιολόγησης — ' + review.author;
          this.dialog.querySelector('[data-review-caption]').textContent = review.author;
          this._photoTrigger = photoButton;
          this.dialog.showModal();
        }
        if (event.target.closest('[data-review-close]')) this.dialog.close();
      }, options);
      this.dialog.addEventListener('click', event => { if (event.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => this._photoTrigger?.focus({ preventScroll: true }), options);
      this.render(false);
    }
    element(tag, className, text) {
      const element = document.createElement(tag);
      if (className) element.className = className;
      if (text !== undefined) element.textContent = text;
      return element;
    }
    render(moveFocus) {
      let rows = this.reviews.slice();
      if (this.sort === 'high') rows.sort((a, b) => b.stars - a.stars || a.id - b.id);
      if (this.sort === 'low') rows.sort((a, b) => a.stars - b.stars || a.id - b.id);
      if (this.sort === 'photos') rows = rows.filter(row => row.image);
      const total = Math.max(1, Math.ceil(rows.length / this.pageSize));
      this.page = Math.min(Math.max(1, this.page), total);
      const offset = (this.page - 1) * this.pageSize;
      const fragment = document.createDocumentFragment();
      rows.slice(offset, offset + this.pageSize).forEach(review => {
        const article = this.element('article', 'kav-customer-review');
        const stars = this.element('div', 'kav-review-stars', '★'.repeat(review.stars) + '☆'.repeat(5 - review.stars));
        stars.setAttribute('aria-label', review.stars + ' από 5 αστέρια');
        const meta = this.element('div', 'kav-review-meta');
        const avatar = this.element('span', 'kav-review-avatar');
        avatar.setAttribute('aria-hidden', 'true');
        // Static icon; all customer content is inserted through textContent.
        avatar.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4 21v-3a8 8 0 0 1 16 0v3Z"/></svg>';
        meta.append(avatar, this.element('strong', '', review.author));
        if (review.verified) meta.append(this.element('span', 'kav-verified', 'ΕΠΑΛΗΘΕΥΜΕΝΗ'));
        article.append(stars, meta);
        if (review.title) article.append(this.element('h3', '', review.title));
        article.append(this.element('p', '', review.body));
        if (review.image) {
          const button = this.element('button', 'kav-review-photo');
          button.type = 'button'; button.dataset.reviewPhoto = review.id;
          button.setAttribute('aria-label', 'Προβολή φωτογραφίας — ' + review.author);
          const image = this.element('img');
          image.src = review.image; image.alt = 'Φωτογραφία αξιολόγησης — ' + review.author;
          image.width = image.height = 80; image.loading = 'lazy';
          button.append(image); article.append(button);
        }
        fragment.append(article);
      });
      this.list.replaceChildren(fragment);
      this.status.textContent = (rows.length ? offset + 1 : 0) + '–' + Math.min(offset + this.pageSize, rows.length) + ' από ' + rows.length + ' αξιολογήσεις';
      this.pagination.replaceChildren();
      const addPage = (number, label, name, disabled) => {
        const button = this.element('button', '', label);
        button.type = 'button'; button.dataset.reviewPage = number; button.disabled = disabled;
        button.setAttribute('aria-label', name);
        if (String(number) === String(this.page) && /^\d+$/.test(label)) button.setAttribute('aria-current', 'page');
        this.pagination.append(button);
      };
      addPage(1, 'Ⅰ‹', 'Πρώτη σελίδα', this.page === 1);
      addPage(this.page - 1, '‹', 'Προηγούμενη σελίδα', this.page === 1);
      const start = Math.max(1, Math.min(this.page - 1, total - 3));
      for (let number = start; number <= Math.min(total, start + 3); number++) addPage(number, String(number), 'Σελίδα ' + number, false);
      addPage(this.page + 1, '›', 'Επόμενη σελίδα', this.page === total);
      addPage(total, '›Ⅰ', 'Τελευταία σελίδα', this.page === total);
      if (moveFocus) { this.list.focus({ preventScroll: true }); this.scrollIntoView({ block: 'start', behavior: 'instant' }); }
    }
    disconnectedCallback() { this._abort?.abort(); this._abort = null; this.dialog?.close(); }
  });
})();

(() => {
  if (customElements.get('kassandra-ph-videos')) return;
  customElements.define('kassandra-ph-videos', class extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const options = { signal: this._abort.signal };
      const videos = [...this.querySelectorAll('video')];
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-kav-video-start]');
        if (!button) return;
        const frame = button.closest('.kav-video-frame');
        const video = frame.querySelector('video');
        video.muted = true;
        const error = frame.querySelector('[data-kav-video-error]');
        error.hidden = true;
        video.play().then(() => { video.focus({ preventScroll: true }); }).catch(() => { error.hidden = false; });
      }, options);
      videos.forEach(video => {
        video.addEventListener('play', () => {
          videos.forEach(other => { if (other !== video) other.pause(); });
          video.closest('.kav-video-frame').classList.add('is-started');
        }, options);
        video.addEventListener('ended', () => video.closest('.kav-video-frame').classList.remove('is-started'), options);
      });
      // Pause off-screen playback without loading any of the videos automatically.
      if ('IntersectionObserver' in window) {
        this._observer = new IntersectionObserver(entries => entries.forEach(entry => { if (!entry.isIntersecting) entry.target.pause(); }), { threshold: 0.05 });
        videos.forEach(video => this._observer.observe(video));
      }
    }
    disconnectedCallback() {
      this._abort?.abort(); this._abort = null; this._observer?.disconnect();
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
})();

/* A disclosed daily countdown, synchronized to Europe/Athens. */
(() => {
  if (customElements.get('kassandra-ph-daily-timer')) return;
  const formatter = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Athens', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
  });
  const partsAt = timestamp => Object.fromEntries(formatter.formatToParts(new Date(timestamp))
    .filter(part => part.type !== 'literal').map(part => [part.type, Number(part.value)]));
  const nextMidnight = now => {
    const local = partsAt(now);
    const target = Date.UTC(local.year, local.month - 1, local.day + 1);
    let candidate = target;
    for (let step = 0; step < 3; step++) {
      const part = partsAt(candidate);
      const wallTime = Date.UTC(part.year, part.month - 1, part.day, part.hour, part.minute, part.second);
      candidate = target - (wallTime - candidate);
    }
    return candidate;
  };
  customElements.define('kassandra-ph-daily-timer', class extends HTMLElement {
    connectedCallback() {
      if (this._interval) return;
      const clock = this.querySelector('[data-kav-daily-clock]');
      if (!clock) return;
      const update = () => {
        const now = Date.now();
        if (!this._end || now >= this._end || this._end - now > 90000000) this._end = nextMidnight(now);
        const seconds = Math.max(0, Math.ceil((this._end - now) / 1000));
        clock.textContent = [Math.floor(seconds / 3600), Math.floor(seconds % 3600 / 60), seconds % 60]
          .map(value => String(value).padStart(2, '0')).join(':');
        this.hidden = false;
      };
      update();
      this._interval = setInterval(update, 1000);
      this._onVisible = () => { if (!document.hidden) update(); };
      document.addEventListener('visibilitychange', this._onVisible);
    }
    disconnectedCallback() {
      clearInterval(this._interval); this._interval = null;
      document.removeEventListener('visibilitychange', this._onVisible);
    }
  });
})();



